/**
 * Fetch all paginated data from backend (auto loop until finish)
 * @param {Function} apiFn - fungsi API yang menerima {page, per_page} dan return axios response
 * @param {Number} perPage - jumlah data per page
 * @returns {Array} full data
 */
export const fetchAllData = async (apiFn, perPage = 100, params) => {
    let page = 1;
    let allData = [];
    let hasNextPage = true;

    while (hasNextPage) {
        const response = await apiFn({ page, per_page: perPage, ...params });
        console.log(response);
        const payload = response.data.data;   // sesuaikan struktur responsenya

        if (!payload || !payload.data) break;

        allData = [...allData, ...payload.data];

        // Stop condition
        hasNextPage = payload.next_page_url !== null;
        page++;
    }

    return allData;
};
